import React, { useState } from 'react';
import { DirectPublishingModalView, DirectPublishingModalViewProps } from './DirectPublishingModal.view';

export type DirectPublishingModalControllerProps = Omit<DirectPublishingModalViewProps, 'loading' | 'setLoading'> & {
  // extend your DirectPublishingModalViewProps
};

export const DirectPublishingModalController = (props: DirectPublishingModalControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const [loading, setLoading] = useState(false);
  const viewProps: DirectPublishingModalViewProps = { ...props, loading, setLoading };
  return <DirectPublishingModalView {...viewProps} />;
};
